import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
  
    {
      name: "Hvad er personoplysninger?",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/1_hvad_er_personoplysninger_be8rye.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Hvornår må du behandle personoplysninger?",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/2_hvorna_r_ma_du_behandle_personoplysninger_oh4cyv.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Samtykke - hvornår og hvordan?",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/3_samtykke_hvorna_r_og_hvordan_hlujxq.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Hvordan laver man en god persondatapolitik?",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/4_hvordan_laver_man_en_god_persondatapolitik_qp5oav.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "De registreredes rettigheder og virksomhedernes forpligtelser",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/5_de_registreredes_rettigheder_og_virksomhedernes_forpligtelser_sxeuvc.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    {
      name: "Sletning - hvornår og hvordan?",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/6_sletning_hvorna_r_og_hvordan_eo1660.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },


    {
      name: "Cookies",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/16_cookies.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
   

    {
      name: "Cloudbaserede tjenester",
      cover:
        "https://storage.googleapis.com/tepedu/images/reel2.png",
      artist: "",
      audio: "https://storage.googleapis.com/tepedu/podcast_om_GDPR_fra_datatilsynet/14_cloud_allan_victor_rkgjdi.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },

    

      //ADD MORE HERE
  ];
}

export default chillHop;
